import { useEffect, useRef, useState } from 'react';
import { Wifi, WifiOff } from 'lucide-react';
import { useOnlineStatus } from '../hooks/useOnlineStatus';

/** Subtiele, niet-blokkerende melding bij verbroken verbinding, met korte bevestiging bij terugkeer. */
export function OfflineBanner() {
  const online = useOnlineStatus();
  const wasOffline = useRef(false);
  const [backOnline, setBackOnline] = useState(false);

  useEffect(() => {
    if (!online) {
      wasOffline.current = true;
      setBackOnline(false);
      return;
    }
    if (!wasOffline.current) return;
    wasOffline.current = false;
    setBackOnline(true);
    const id = window.setTimeout(() => setBackOnline(false), 2500);
    return () => window.clearTimeout(id);
  }, [online]);

  if (online && !backOnline) return null;
  return (
    <div role="status" className="pointer-events-none fixed inset-x-0 top-3 z-[110] flex justify-center px-4">
      <div className="flex items-center gap-2 rounded-2xl bg-slate-900/90 px-4 py-2 text-sm text-slate-50 backdrop-blur-md dark:bg-slate-100/90 dark:text-slate-900">
        {online ? <Wifi size={16} aria-hidden /> : <WifiOff size={16} aria-hidden />}{' '}
        {online ? 'Weer online' : 'Offline: de app werkt gewoon door, je gegevens blijven bewaard.'}
      </div>
    </div>
  );
}
